import requestFunctions from "../../functions/requestFunctions";


export const state = {
    BLOCKS: []
}

export const getters = {
    GET_BLOCKS: (state) => {
        return state.BLOCKS;
    }
}

export const mutations = {
    UPDATE_BLOCKS(state, list) {
        state.BLOCKS = list;
        // console.log('UPDATE BLOCKS')
        // console.log(list)
    }
}

export const actions = {
    async SET_BLOCKS({ commit }, payload) {
        commit('UPDATE_BLOCKS', payload.blocks);
    }
}